// Single source of truth for the Lead Kanban's 5-stage pipeline — shared by the board, the card,
// and the capture form so the stage list/order/colors can never drift between them. Colors step
// from cool grey through to scarlet as a lead gets closer to converting — a deliberate "heating
// up" visual cue (WOW-factor per product ask) rather than 5 arbitrary colors.
export const LEAD_STAGES = [
  { key: "new_lead", label: "New Lead", color: "#6B6B70", bg: "#F1F0EC" },
  { key: "contacted", label: "Contacted", color: "#2563EB", bg: "#EAF1FE" },
  { key: "interested", label: "Interested", color: "#B45309", bg: "#FDF1E3" },
  { key: "demo_trial", label: "Demo / Trial", color: "#7C3AED", bg: "#F3ECFC" },
  { key: "negotiation", label: "Negotiation", color: "#D6202B", bg: "#FDEDF0" },
];

export const LEAD_STAGE_BY_KEY = Object.fromEntries(LEAD_STAGES.map((s) => [s.key, s]));

export function leadStageLabel(key) {
  return LEAD_STAGE_BY_KEY[key]?.label || key;
}
